module.exports = {
	sentryDSN: process.env.SENTRY_DSN ?? '',
	sentryOrg: process.env.SENTRY_ORG ?? '',
	sentryProject: process.env.SENTRY_PROJECT ?? '',
	environment: process.env.ENVIRONMENT,
	isProd: process.env.ENVIRONMENT === 'production',
};
